import MasterData from "../../../jsx/components/Dashboard/MasterData/MasterData";

const MasterdataWrapper = () => {
  return <MasterData />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(MasterdataWrapper);
